<template>
  <div class="roadblock bf-background">
    <div class="roadblock-content">
      <div class="cta">
        <h5>
          <span class="d-block">Peace, love, &amp; tools.</span>
          Right in your inbox.
        </h5>
        <p>
          <strong>Discover, buy, and sell</strong> tools to grow your business.
          <br class="d-xs-block d-none">Join the marketplace trusted by 1M+ entrepreneurs.
        </p>
        <form v-if="!isEmailSubmitted" @submit.prevent="$_asyncSubmitEmail">
          <input
            v-model="emailAddress"
            type="email"
            name="email"
            placeholder="Email"
            aria-label="Email"
          >
          <button
            type="submit"
            :disabled="isProcessing"
          >
            Send me tools
          </button>
        </form>
        <div v-if="isEmailSubmitted" class="success">
          <img src="~/static/success-tick.svg" alt="">
          <span>
            <strong>You're in!</strong>  Thanks for signing up.
          </span>
        </div>
      </div>
    </div>
    <img
      :src="BannerLeft"
      class="d-lg-block d-none roadblock-banner-left"
      alt="Left image"
    >
    <img
      :src="BannerRight"
      class="d-lg-block d-none roadblock-banner-right"
      alt="Right image"
    >
  </div>
</template>
<script>
import BannerLeft from '~/static/roadblocks/bf-email-left.svg';
import BannerRight from '~/static/roadblocks/bf-email-right.svg';
import SubmitEmailMixin from '../../mixins/submit-email';

export default {
  mixins: [SubmitEmailMixin],
  data() {
    return {
      BannerLeft,
      BannerRight,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/dorado/main';
@import '~/styles/utils/breakpoints';

.roadblock {
  margin-bottom: 60px;
  margin-left: -30px;
  margin-right: -30px;
  padding: 32px 64px;
}

.roadblock-content {
  display: flex;
  flex-direction: column;
}

.bf-background {
  background: #fff5db;
}

.roadblock-banner-left {
  left: 0;
  position: absolute;
  bottom: 0;
  height: 90%;
}

.roadblock-banner-right {
  right: 0;
  position: absolute;
  bottom: 0;
  height: 90%;
}

.image {
  flex: 1 0 0;
  padding-left: 16px;
}

.image img {
  max-height: 320px;
  width: 100%;
}

.success {
  background: $money-moss;
  padding: 16px 20px;
  color: #fff;
  display: inline-flex;
  align-items: center;
}

.success img {
  margin-right: 16px;
}

.cta {
  flex: 1 0 0;
}

.cta h5 {
  font-family: Barlow, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 42px;
  margin-bottom: 10px;
}

.cta h5 span {
  color: #07c93b;
}

.cta p {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
}

.cta input {
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #000;
  font-size: 16px;
  padding: 6px 12px;
  width: 285px;
}

.cta button {
  background: $dorado;
  border-radius: 40px;
  color: $gray-900;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 24px;
  text-decoration: none;
  border: 0;
  margin-left: 8px;
  text-align: center;
}

.cta button:focus {
  border: 0;
  outline: none;
}

.cta button:disabled {
  color: rgba(27, 27, 27, 0.5);
}

@include media-breakpoint-up(sm) {
  .roadblock-content {
    align-items: center;
    flex-direction: row;
    margin: 0 auto;
    max-width: 1140px;
  }
}

@include media-breakpoint-up(md) {
  .bf-background {
    .roadblock-content {
      max-width: 500px;
    }
  }
}

@include media-breakpoint-up(lg) {
  .bf-background {
    background-image: url(~/static/roadblocks/rays.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    align-items: center;
    background-color: #fff5db;
    justify-content: center;
    min-height: 440px;
    position: relative;

    .roadblock-content {
      top: -50%;
      transform: translateY(50%);
    }
  }
}

@include media-breakpoint-down(xs) {
  .cta {
    order: 2;
  }

  .cta h5 {
    text-align: center;
  }

  .cta p {
    text-align: center;
  }

  .cta input {
    width: 100%;
  }

  .cta button {
    margin: 16px 0 0;
    width: 100%;
  }

  .image {
    order: 1;
    margin-bottom: 35px;
  }

  .image img {
    margin: 0 auto;
    display: block;
  }
}

@include media-breakpoint-down(sm) {
  .cta h5 {
    font-size: 32px;
  }

  .roadblock {
    margin-left: -20px;
    margin-right: -20px;
    padding: 32px;
  }
}

@media (min-width: 1024px) {
  .image img {
    height: 280px;
  }
}
</style>
